// ----------------------------------------------------------------------

export function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ xs, sm, md, lg }) {
  return {
    '@media (max-width:600px)': {
      fontSize: xs,
    },
    '@media (min-width:600px)': {
      fontSize: sm,
    },
    '@media (min-width:900px)': {
      fontSize: md,
    },
    '@media (min-width:1200px)': {
      fontSize: lg,
    },
  };
}

// ----------------------------------------------------------------------

// const FONT_PRIMARY = '"Russo One", serif'
const FONT_PRIMARY = '"Bebas Neue", serif'
const FONT_SECONDARY = '"Manrope", serif'; // Local Font

const typography = {
  fontFamily: FONT_SECONDARY,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  h1: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: "76.8px",
    fontSize: 80,
    textTransform: "Uppercase"
    // ...responsiveFontSizes({ xs: 40, sm: 40, md: 40, lg: 40 }),
    // letterSpacing:" 1.6px",

  },
   subH1: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: "60px",
    fontSize: 40,
    textTransform: 'none',
  },
  h2: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: "53.76px",
    fontSize: 56,
    textTransform: 'none',
  },
  subH2: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: "48px",
    fontSize: 32,
    textTransform: 'none',
  },
  h3: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 700,
    lineHeight: '26.88px',
    fontSize: 28,
    textTransform: 'Uppercase',
  },
  subH3: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
    lineHeight: '36px',
    fontSize: 24,
  },
  h4: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(20),
    ...responsiveFontSizes({ sm: 20, md: 24, lg: 24 }),
  },
  subH4: {
    fontFamily: FONT_SECONDARY,
    fontWeight: 700,
     lineHeight: '30px',
    fontSize: 20,
  },
  h5: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(18),
    ...responsiveFontSizes({ sm: 19, md: 20, lg: 20 }),
  },
  h6: {
    fontFamily: FONT_PRIMARY,
    fontWeight: 400,
    lineHeight: 28 / 18,
    fontSize: pxToRem(17),
    ...responsiveFontSizes({ sm: 18, md: 18, lg: 18 }),
  },
  subtitle1: {
    fontWeight: 600,
    lineHeight: "24px",
    fontSize: "16px",
  },
  subtitle2: {
    lineHeight: '24px',
    fontSize: 18,
    fontFamily: FONT_SECONDARY,
    fontWeight: 800,
  },
  body1: {
    fontSize: 16,
    fontStyle: 'normal',
    lineHeight: '28px',
    fontWeight: '600',
    fontFamily: FONT_SECONDARY,
  },
  body2: {
    fontSize: 16,
    fontStyle: 'normal',
    lineHeight: '28px',
    fontWeight: '600',
    fontFamily: FONT_SECONDARY,
  },
  body3: {
    fontSize: 16,
    fontStyle: 'normal',
    lineHeight: '28px',
    fontWeight: '400',
    fontFamily: FONT_SECONDARY,
  },
  overline: {
    fontWeight: 400,
    lineHeight: 1.5,
    fontSize: pxToRem(12),
    textTransform: 'uppercase',
  },
  headline: {
    fontSize: 16,
    fontStyle: 'normal',
    lineHeight: '24px',
    fontWeight: '600',
    fontFamily: FONT_SECONDARY,
  },
  caption: {
    fontSize: 12,
    fontStyle: 'normal',
    lineHeight: '16px',
    fontWeight: '600',
    fontFamily: FONT_SECONDARY,
  },
  button: {
    fontWeight: 600,
    lineHeight: '24px',
    fontSize: '16px',
    textTransform: 'normal',
    fontFamily: FONT_SECONDARY,

  },
};

export default typography;
